import React from 'react';
import { Navbar, Footer, ScrollToTop } from './components';
import {
  HeroSection,
  StatsSection,
  AboutSection,
  ServicesSection,
  ProjectsSection,
  SkillsSection,
  EducationSection,
  ContactSection
} from './sections';
import { useMousePosition, useScrollPosition, useIntersectionObserver, useTheme } from './hooks';
import './styles/globals.css';

function App() {
  const mousePosition = useMousePosition();
  const { activeSection, setActiveSection, showScrollTop } = useScrollPosition();
  const isVisible = useIntersectionObserver();
  const { theme, toggleTheme } = useTheme();

  return (
    <div
      className="portfolio-root min-h-screen text-white selection:bg-emerald-500/30"
      style={{ backgroundColor: 'var(--bg-primary)', color: 'var(--text-primary)', transition: 'background-color 0.3s ease, color 0.3s ease' }}
    >
      <div
        className="cursor-glow hidden lg:block"
        style={{ left: mousePosition.x, top: mousePosition.y }}
      />

      <Navbar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        theme={theme}
        toggleTheme={toggleTheme}
      />

      <main>
        <HeroSection setActiveSection={setActiveSection} />
        <StatsSection />
        <AboutSection isVisible={isVisible.about} />
        <ServicesSection isVisible={isVisible.services} />
        <ProjectsSection isVisible={isVisible.projects} />
        <SkillsSection isVisible={isVisible.skills} />
        <EducationSection />
        <ContactSection isVisible={isVisible.contact} />
      </main>

      <Footer setActiveSection={setActiveSection} />

      <ScrollToTop show={showScrollTop} />
    </div>
  );
}

export default App;
